<template>
  <div class="cart-item">
    <div class="row">
      <div class="col-12 mb-2">
        <icon :icon="icon" class="cart-item-icon svg-icon float-left" />
        <div
          class="text-uppercase font-weight-bold text-primary float-left font-size-sm pl-2 pt-2"
        >
          {{ subtitle }}
        </div>
      </div>
      <div class="col-6">
        <h4 class="mb-2 text-dark">{{ title }}</h4>
        <h3 v-if="!isEvent" class="mb-2">{{ item.cost | cost }}</h3>
        <div v-else class="cart-item-details">
          <span class="dt mr-2">Event ID:</span>
          <span class="dd">{{ item.enrollable.id }}</span>
        </div>
        <div v-if="!!item.nate_credit_available" class="cart-item-details">
          <span class="dt mr-2">NATE Credit?:</span>
          <span class="dd">
            <span v-if="!!item.nate_id">{{
              `Yes (NATE ID: ${item.nate_id})`
            }}</span>
            <span v-else>No</span>
          </span>
        </div>
      </div>
      <div class="col-6 cart-item-details">
        <div class="row">
          <div class="dt col-3">Student:</div>
          <div class="dd col-9">
            <strong>{{ item.user.name }}</strong>
            <div v-if="item.user.hvac_id">(ID: {{ item.user.hvac_id }})</div>
          </div>
        </div>
        <div class="row">
          <div class="dt col-3">Company:</div>
          <div class="dd col-9">
            <strong>{{ item.user.company.name }}</strong>
            <div v-if="item.user.company.hvac_id">
              (ID: {{ item.user.company.hvac_id }})
            </div>
          </div>
        </div>
        <div class="row">
          <div class="dt col-3">Brand:</div>
          <div class="dd col-9">
            <strong>{{ item.brand.name }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
  computed: {
    isCourse() {
      return !!this.item.item_type && this.item.item_type === "course";
    },
    isEvent() {
      return !!this.item.item_type && this.item.item_type === "event";
    },
    isLearningPath() {
      return !!this.item.item_type && this.item.item_type === "learning_path";
    },
    icon() {
      if (this.isLearningPath) {
        return "grad-cap";
      } else if (this.isEvent) {
        return "calendar";
      } else {
        return "courses";
      }
    },
    subtitle() {
      if (this.isLearningPath) {
        return "Learning Path";
      } else if (this.isEvent) {
        return `${this.item.enrollable.type_label} Event`;
      } else {
        return "Online Course";
      }
    },
    title() {
      if (this.isLearningPath) {
        return this.item.learningPath.name;
      } else if (this.isEvent) {
        return `${this.item.enrollable.name} - ${this.$moment(
          this.item.enrollable.start_date
        ).format("MM/DD/YY")}`;
      } else {
        return this.item.enrollable.name;
      }
    },
  },
};
</script>